import IBubbleRoom from '../types/room';
import { generateSlug, RandomWordOptions } from 'random-word-slugs';

function getRandomPositiveInt(max: number) {
  return Math.floor(Math.random() * max);
}

export function generateRoomCode(): string {
  const options: RandomWordOptions<2> = {
    format: 'kebab',
    partsOfSpeech: ['adjective', 'noun'],
    categories: {
      adjective: ['personality', 'appearance'],
      noun: ['animals', 'food']
    }
  };
  return `${generateSlug(2, options)}-${getRandomPositiveInt(50)}`;
}

export function createNewBubbleRoom(): IBubbleRoom {
  return {
    messages: {},
    users: {},
    video: {
      isPlaying: false,
      url: '',
      elapsed: 0
    },
    numReacts: 0
  };
}
